import { OverviewUserDataComponent } from './progress/pages/overview-user-data/overview-user-data.component';
import { InvestimentBrokerComponent } from './pages/investiment-broker/investiment-broker.component';
import { DetailsComponent } from './shared/page/details/details.component';
import { AddressCityComponent } from './address/pages/address-city/address-city.component';
import { NifComponent } from './income-wealth/pages/nif/nif.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdjuntPageComponent } from './address/pages/address-adjunt/adjunt.page';
import { AddressNamePageComponent } from './address/pages/address-name/address-name.page';
import { AddressNumberPageComponent } from './address/pages/address-number/address-number.page';
import { CepPageComponent } from './address/pages/cep/cep.page';
import { DistrictPageComponent } from './address/pages/district/district.page';
import { ErrorComponent } from './error/error.component';
import { IncomePageComponent } from './income-wealth/pages/income/income.page';
import { MaritalStatusPageComponent } from './marital-status/pages/marital-status/marital-status.page';
import { BirthCountryComponent } from './personal-data/pages/birth-country/birth-country.component';
import { BirthStateComponent } from './personal-data/pages/birth-state/birth-state.component';
import { DocumentIssuingComponent } from './personal-data/pages/document-issuing/document-issuing.component';
import { DocumentNameComponent } from './personal-data/pages/document-name/document-name.component';
import { DocumentNumberComponent } from './personal-data/pages/document-number/document-number.component';
import { DocumentTypeComponent } from './personal-data/pages/document-type/document-type.component';
import { ExpeditionStateComponent } from './personal-data/pages/expedition-state/expedition-state.component';
import { NationalityComponent } from './personal-data/pages/nationality/nationality.component';
import { ParentageComponent } from './personal-data/pages/parentage/parentage.component';
import { ProfessionPageComponent } from './professional-data/Pages/profession/profession.page';
import { RouterGuard } from './shared/service/router-guard/router-guard';
import { BirthCityComponent } from './personal-data/pages/birth-city/birth-city.component';
import { GenderComponent } from './personal-data/pages/gender/gender.component';
import { OriginIncomeComponent } from './professional-data/Pages/origin-income/origin-income.component';
import { CompanyInformationComponent } from './professional-data/Pages/company-information/company-information';
import { PatrimonyPageComponent } from './income-wealth/pages/patrimony/patrimony.page';
import { ErrorIncomePageComponent } from './income-wealth/pages/error-income/error-income.page';
import { SpouseComponent } from './marital-status/pages/spouse/spouse.component';
import { TaxResidencyPageComponent } from './income-wealth/pages/tax-residency/tax-residency.page';
import { TaxResidencyCountryComponent } from './income-wealth/pages/tax-residency-country/tax-residency-country.component';
import { DateTaxResidencyComponent } from './income-wealth/pages/date-tax-residency/date-tax-residency.component';
import { AddressStateComponent } from './address/pages/address-state/address-state.component';
import { OverviewComponent } from "./progress/pages/overview/overview.component";
import { SettingsComponent } from "./shared/page/settings/settings.component";
import { LoadingComponent } from "./pages/loading/loading.component";
import { ClientDataComponent } from './client-data/pages/client-data/client-data.component';
import { NameComponent } from './profile-data/pages/name/name.component';
import { EmailComponent } from './profile-data/pages/email/email.component';
import { DateBirthComponent } from './personal-data/pages/date-birth/date-birth.component';
import { PhoneComponent } from './profile-data/pages/phone/phone.component';
import { DataAnalysisComponent } from "./pages/data-analysis/data-analysis.component";
import { InfoDataPage } from "./professional-data/Pages/info-data/info-data.page";
import { PepComponent } from "./professional-data/Pages/pep/pep.component";
import { BrokerRegistrationComponent } from './pages/broker-registration/broker-registration.component';
import { TermsComponent } from './pages/terms/terms.component';
import { OverviewErrorComponent } from './progress/pages/error-overview/overview-error.component';
import { FirstAccessScreenComponent } from './pages/first-access-screen/first-access-screen.component';
import { AddressCompletedPageComponent } from './address/pages/address-completed/address-completed.page';
import { RlpComponent } from './pages/rlp/rlp.component';
import { DetailsFaqComponent } from './shared/page/details-faq/details-faq.component';
import { NewProductsComponent } from './pages/new-products/new-products.component';
import { MinorComponent } from './pages/minor/minor.component';
import { OverviewUserDataNotEditableComponent } from './progress/pages/overview-user-data-not-editable/overview-user-data-not-editable.component';

const routes: Routes = [
  {
    path: '',
    canActivate: [RouterGuard],
    component: LoadingComponent,
  },
  {
    path: 'page/error',
    component: ErrorComponent
  },
  {
    path: 'error/error-income',
    component: ErrorIncomePageComponent
  },
  {
    path: 'status/overview',
    component: OverviewComponent
  },
  {
    path: 'tools/settings',
    component: SettingsComponent
  },
  {
    path: 'personal-data/document-type',
    canActivate: [RouterGuard],
    component: DocumentTypeComponent,
  },
  {
    path: 'personal-data/document-name',
    canActivate: [RouterGuard],
    component: DocumentNameComponent
  },
  {
    path: 'personal-data/document-number',
    canActivate: [RouterGuard],
    component: DocumentNumberComponent
  },
  {
    path: 'personal-data/document-issuing',
    canActivate: [RouterGuard],
    component: DocumentIssuingComponent
  },
  {
    path: 'personal-data/date-birth',
    canActivate: [RouterGuard],
    component: DateBirthComponent
  },
  {
    path: 'personal-data/expedition-state',
    canActivate: [RouterGuard],
    component: ExpeditionStateComponent
  },
  {
    path: 'personal-data/birth-country',
    canActivate: [RouterGuard],
    component: BirthCountryComponent
  },
  {
    path: 'personal-data/birth-state',
    canActivate: [RouterGuard],
    component: BirthStateComponent
  },
  {
    path: 'personal-data/birth-city',
    canActivate: [RouterGuard],
    component: BirthCityComponent
  },
  {
    path: 'personal-data/gender',
    canActivate: [RouterGuard],
    component: GenderComponent
  },
  {
    path: 'personal-data/parentage',
    canActivate: [RouterGuard],
    component: ParentageComponent
  },
  {
    path: 'personal-data/nationality',
    canActivate: [RouterGuard],
    component: NationalityComponent
  },
  {
    path: 'marital-status/marital-status',
    canActivate: [RouterGuard],
    component: MaritalStatusPageComponent
  },
  {
    path: 'marital-status/spouse',
    canActivate: [RouterGuard],
    component: SpouseComponent
  },
  {
    path: 'address/cep',
    canActivate: [RouterGuard],
    component: CepPageComponent
  },
  {
    path: 'address/completed',
    canActivate: [RouterGuard],
    component: AddressCompletedPageComponent
  },
  {
    path: 'address/name',
    canActivate: [RouterGuard],
    component: AddressNamePageComponent
  },
  {
    path: 'address/number',
    canActivate: [RouterGuard],
    component: AddressNumberPageComponent
  },
  {
    path: 'address/adjunt',
    canActivate: [RouterGuard],
    component: AdjuntPageComponent
  },
  {
    path: 'address/district',
    canActivate: [RouterGuard],
    component: DistrictPageComponent
  },
  {
    path: 'address/state',
    canActivate: [RouterGuard],
    component: AddressStateComponent
  },
  {
    path: 'address/city',
    canActivate: [RouterGuard],
    component: AddressCityComponent
  },
  {
    path: 'professional-data/origin-income',
    canActivate: [RouterGuard],
    component: OriginIncomeComponent
  },
  {
    path: 'professional-data/profession',
    canActivate: [RouterGuard],
    component: ProfessionPageComponent
  },
  {
    path: 'professional-data/company-cnpj',
    canActivate: [RouterGuard],
    component: CompanyInformationComponent
  },
  {
    path: 'income/income-wealthincome',
    canActivate: [RouterGuard],
    component: IncomePageComponent
  },
  {
    path: 'income/patrimony',
    canActivate: [RouterGuard],
    component: PatrimonyPageComponent
  },
  {
    path: 'income/tax-residency',
    canActivate: [RouterGuard],
    component: TaxResidencyPageComponent
  },
  {
    path: 'income/tax-residency-country',
    canActivate: [RouterGuard],
    component: TaxResidencyCountryComponent
  },
  {
    path: 'income/nif',
    canActivate: [RouterGuard],
    component: NifComponent
  },
  {
    path: 'income/date-tax-residency',
    canActivate: [RouterGuard],
    component: DateTaxResidencyComponent
  },
  {
    path: 'data/client-data',
    canActivate: [RouterGuard],
    component: ClientDataComponent
  },
  {
    path: 'profile/name',
    canActivate: [RouterGuard],
    component: NameComponent
  },
  {
    path: 'profile/email',
    canActivate: [RouterGuard],
    component: EmailComponent
  },
  {
    path: 'profile/phone',
    canActivate: [RouterGuard],
    component: PhoneComponent
  },
  {
    path: 'terms',
    canActivate: [RouterGuard],
    component: TermsComponent
  },
  {
    path: 'details',
    canActivate: [RouterGuard],
    component: DetailsComponent
  },
  {
    path: 'details-faq',
    canActivate: [RouterGuard],
    component: DetailsFaqComponent
  },
  {
    path: 'broker',
    canActivate: [RouterGuard],
    component: InvestimentBrokerComponent
  },
  {
    path: 'overview-status/overview-user',
    canActivate: [RouterGuard],
    component: OverviewUserDataComponent
  },
  {
    path: 'overview-validated/overview-user-not-editable',
    canActivate: [RouterGuard],
    component: OverviewUserDataNotEditableComponent
  },
  {
    path: 'professional-data/pep',
    canActivate: [RouterGuard],
    component: PepComponent
  },
  {
    path: 'professional-data/info-data',
    canActivate: [RouterGuard],
    component: InfoDataPage
  },
  {
    path: 'data-analysis',
    canActivate: [RouterGuard],
    component: DataAnalysisComponent
  },
  {
    path: 'broker-registration',
    canActivate: [RouterGuard],
    component: BrokerRegistrationComponent
  },
  {
    path: 'overview-error/overview-error',
    canActivate: [RouterGuard],
    component: OverviewErrorComponent
  },
  {
    path: 'first-access-screen',
    canActivate: [RouterGuard],
    component: FirstAccessScreenComponent
  },
  {
    path: 'rlp',
    canActivate: [RouterGuard],
    component: RlpComponent
  },
  {
    path: 'new-products/new-products',
    canActivate: [RouterGuard],
    component: NewProductsComponent
  },
  {
    path: 'minor',
    canActivate: [RouterGuard],
    component: MinorComponent
  },
  {
    path: 'overview-user-not-editable',
    canActivate: [RouterGuard],
    component: OverviewUserDataNotEditableComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    useHash: true,
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
